import { DiscordOutlined } from "@ant-design/icons";

export const DISCORD_INVITE_URL = "https://discord.gg/CgWkWfQ5MY";

export default function DiscordLink({ size = 14 }) {
  return (
    <a href={DISCORD_INVITE_URL} target="_blank" rel="noreferrer" aria-label="Join the official Age of Companies Discord server" title="Join the Age of Companies Discord">
      <DiscordOutlined style={{ fontSize: size, verticalAlign: "-0.125em" }} />
    </a>
  );
}
